/**
 * Convex client + cookie-to-Convex token sync — v.1-D §7.5.
 *
 * The Payload JWT cookie is the authentication source of truth across the
 * cms.* / app.* sub-domains. `syncAuthToken()` reads that cookie and binds
 * (or clears) the Convex client's bearer token accordingly. The function is
 * invoked once at module load; route guards re-invoke it after sign-in.
 *
 * Ported verbatim by T304 from `frontend-v2/src/lib/convex.ts`. The
 * single-instance / module-singleton property is load-bearing for FR-002
 * ("the provider tree initializes ... exactly one reactive client exists")
 * and is pinned by the T303 foundation test
 * (`tests/foundation/env.test.ts` — "exports a single `convex` instance").
 */
import { ConvexReactClient } from 'convex/react';
import { env } from './env';
import { COOKIE_NAME, CSRF_HEADER_NAME } from './payloadAuth';
import { logger } from './logger';

function getTokenFromCookie(): string | null {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, ...rest] = cookie.trim().split('=');
    if (name === COOKIE_NAME) return rest.join('=') || null;
  }
  return null;
}

export const convex = new ConvexReactClient(env.CONVEX_URL);

export function syncAuthToken(): void {
  const token = getTokenFromCookie();
  if (token) {
    convex.setAuth(async () => token);
    logger.debug('convex_auth_token_bound', { hasToken: true });
  } else {
    convex.clearAuth();
    logger.debug('convex_auth_token_cleared', { hasToken: false });
  }
}

syncAuthToken();

export { getTokenFromCookie, CSRF_HEADER_NAME };
